<template>
  <div class="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',

  data() {
    return {
      //
    };
  },

  components: {
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto&subset=cyrillic');

html, body {
  position: relative;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

#app {
  font-family: system-ui;
  position: relative;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  min-height: 100%;
}

.app {
  font-family: system-ui;

  &__main-container {
    position: relative;
    min-height: calc(100% - 60px);
  }

  &__nav-item {
    text-decoration: none;
  }
}

.el-header {
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
  min-height: calc(100% - 60px);
}
</style>
